<template>
  <div class="vx-row pt-5 mt-5">
    <div class="vx-col w-full text-center">
      <div class="vx-row pt-5 mt-5" v-if="!override">
        <div class="vx-col w-full text-center">
          <pre class="py-5 my-5">{{ localeResource.$getEmbedded('default-message').message }}</pre>
          <vs-button color="primary" @click.native="onPrepareOverride">I want to personalize this message</vs-button>
        </div>
      </div>
      <div class="vx-row pt-5 mt-5" v-if="override">
        <div class="vx-col w-full text-center">
          <vs-textarea :color="loading? 'warning':''" :label="loading?'Saving in progress...':'Enter your message here'" v-model="innerMessage" @input="debounceInput" rows="8"/>
        </div>
        <div class="vx-col w-full text-center">
          <vs-button color="warning" @click.native="onCancelOverride">Revert to the default message for
            {{ localeResource.name }} instead
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {ResourceImpl} from 'hal-client';
import _ from 'lodash';

export default {
  name: 'profile-default-message-locale',
  props: {
    profileResource: ResourceImpl,
    localeResource: ResourceImpl
  },
  data (vm) {
    const configuredMessage = vm.localeResource.$hasEmbedded('message') ? vm.localeResource.$getEmbedded('message').message : null;
    return {
      loading: false,
      override: vm.localeResource.$hasEmbedded('message'),
      message: configuredMessage,
      innerMessage: configuredMessage
    };
  },
  watch: {
    localeResource: {
      deep: true,
      handler (val) {
        const configuredMessage = val.$hasEmbedded('message') ? val.$getEmbedded('message').message : null;
        this.override = val.$hasEmbedded('message');
        this.message = configuredMessage;
        this.innerMessage = configuredMessage;
      }
    }
  },
  methods: {
    onPrepareOverride () {
      this.override = true;
      this.message = this.localeResource.$getEmbedded('default-message').message;
      this.innerMessage = this.localeResource.$getEmbedded('default-message').message;
      this.onSave();
    },
    onCancelOverride () {
      this.localeResource.$request().$deleteSelf().then(() => {
        this.override = false;
        this.message = null;
        this.innerMessage = null;
        this.$emit('updated');
      });
    },
    onSave () {
      this.loading = true;
      this.localeResource.$request().$postSelf({
        message: this.message
      }).then(() => {
        this.$emit('updated');
        this.loading = false;
      }).finally(() => {
        this.loading = false;
      });
    },
    debounceInput: _.debounce(function () {
      // eslint-disable-next-line
      this.message = this.innerMessage;
      // eslint-disable-next-line
      this.onSave();
    }, 1000)
  }
};
</script>

<style>
.vs-con-textarea.vs-textarea-warning > h4{
  color:#FF9F43!important;
}
.vs-con-textarea.vs-textarea-warning{
  border-color:#FF9F43!important;
}
</style>
